import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useCallback } from "react";
import { getOperatorEmail, isOperatorMode } from "app/pages/Auth/authSelectors";
import OperatorWidget from "app/pages/.shared/OperatorWidget/OperatorWidget";
import { logout as logoutAction } from "app/pages/Auth/AuthActions";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const mapStateToProps = state => {
	return {
		operatorEmail: getOperatorEmail(state),
		isOperatorMode: isOperatorMode(state),
	};
};

const OperatorWidgetContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const { track } = useAnalytics();
	const logout = useCallback(() => dispatch(logoutAction({ track })), [dispatch, track]);
	return <OperatorWidget {...props} {...stateProps} logout={logout} />;
};

export default OperatorWidgetContainer;
